import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import {
    CommonFilterModel,
    CommonPaginatorResourceService,
    CommonParams
} from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { GridUtils } from '@/shared/util/grid-utils'

export class CustomerGridRatesDatasource<T> extends PaginatorLaboratoryDatasource<T> {
    readonly customerId: number

    constructor(service: CommonPaginatorResourceService<T>, laboratoryId: number, customerId: number) {
        super(service, laboratoryId)
        this.customerId = customerId
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        const _filterModel: CommonFilterModel = {
            'customer.id': GridUtils.getNumberFilterModel('equals', this.customerId),
            ...filterModel
        }
        return this.service.paginator(_filterModel, params, this.laboratoryId)
    }
}
